import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { forgotPassword, apiError } from "@/lib/api";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset password" subtitle="Enter your account email and we'll send you a reset link.">
      {sent ? (
        <div className="space-y-5" data-testid="forgot-sent">
          <div className="flex gap-3 rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
            <CheckCircle2 size={18} className="shrink-0 mt-0.5" />
            <span>If that account exists, a reset link is on its way to <strong>{email}</strong>. It expires in 1 hour.</span>
          </div>
          <Link to="/login" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-800" data-testid="forgot-back-login">
            <ArrowLeft size={14} /> Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="label-caps">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="info@soverenxsystems.com.au" autoFocus className="mt-1.5" data-testid="forgot-email" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={loading || !email} className="w-full gap-2 text-white" style={{ background: "#002FA7" }} data-testid="forgot-submit">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />} Send reset link
          </Button>
          <Link to="/login" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-800" data-testid="forgot-back">
            <ArrowLeft size={14} /> Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPassword;
